import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const LIST_STYLES =
  'flex flex-shrink-0 flex-col py-0 px-2 text-body font-body font-hairline text-sm leading-5 divide-gray-400'
const DIVIDE_STYLES = 'divide-y'
const DOUBLE_STYLES = 'divide-y-4 divide-double'
const NESTED_STYLED = '-mx-2'

export interface ListProps {
  divide?: boolean
  double?: boolean
  className?: string
  nested?: boolean
  marginClassName?: string
  style?: React.CSSProperties
}

export const List: React.FC<PropsWithChildren<ListProps>> = ({
  children,
  divide,
  double,
  className,
  nested,
  marginClassName = 'mx-0 my-4',
  style,
}) => {
  return (
    <ul
      className={concatStyles([
        LIST_STYLES,
        divide ? DIVIDE_STYLES : '',
        double ? DOUBLE_STYLES : '',
        nested ? NESTED_STYLED : '',
        marginClassName,
        className,
      ])}
      style={style}
    >
      {children}
    </ul>
  )
}

List.displayName = 'Content.List'
